
function ObjectGridCtrl($scope, TranslationService, ContactService) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.prefs = {
        name: 'ObjectGrid',
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false,
    };

    ctrl.resetService = ContactService.resetCache;    

    ctrl.getTotal = function () {
        ctrl.loadingTotal = true;
        ctrl.totalItems = 0;
        ctrl.lastSync = null;

        //ContactService.getObjectsCount().then(function (response) {
        //    ctrl.loadingTotal = false;
        //    if (response) {
        //        ctrl.totalItems = response.data.TotalCount;
        //        ctrl.lastSync = response.data.LastSync;
        //    }
        //});
    };

    ctrl.getTotal();

    ctrl.searchMode = function () {
        $scope.$broadcast('inputSearch', ctrl.filterString);
    };

    ctrl.doRefresh = function () {
        $scope.$broadcast('refreshServiceGrid');
    };

    ctrl.toExcel = function () {
        $scope.$broadcast('toExcel', 'rotas');
    };

    ctrl.doInsert = function () {
        $scope.$broadcast('addItem');
    };
    
}

ObjectGridCtrl.$inject = ['$scope','TranslationService', 'ContactService'];

seedWebApp.component('objectGrid', {
    controller: ObjectGridCtrl,
    bindings: {
        name: '<',
        columns: '<',
        loadService: '<',
        overflowSize: '<', //necessario para infinite scroll
        //status: '=',
        //disabled: '<',
        //options: '<',
    },
    templateUrl: '/SPA/Contacts/objectGrid.html'
});

